import request from "../utils/request";

export function loginByEmail(email, password) {
  return request({
    url: "/sysapi/login", // 你的请求路径
    data: { username: email, password }, // 你的请求数据
  });
}

export function logout() {
  // return fetch({
  //   url: "/login/logout",
  //   method: "post",
  // });
}

export function getInfo(token) {
  // return fetch({
  //   url: "/user/info",
  //   method: "get",
  //   params: { token },
  // });
}

export function updatePassword(email,password) {
  return request({
    url: "/sysapi/updatePassword",
    data: { username: email, password }
  });
}

export function getSTS() {
  console.log("====");
  return request({
    url: "/third/sts", // 你的请求路径
    data: {}, // 你的请求数据
  });
}
